<template>
  <div v-if="visible" class="custom-overlay">
    <div class="loader"></div>
  </div>
</template>

<script>
export default {
  props: ["visible"],
};
</script>

<style lang="less" scoped>
@import "../../assets/styles/variables.less";

.custom-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 110;
  background-color: @kk-color-lighter-gray;
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader {
  width: 50px;
  padding: 8px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: @kk-color-primary-blue;
  --_m: conic-gradient(#0000 10%, #000), linear-gradient(#000 0 0) content-box;
  mask: var(--_m);
  mask-composite: subtract;
  animation: spin 1s infinite linear;
}

@keyframes spin {
  to {
    transform: rotate(1turn);
  }
}
</style>
